import { useState } from 'react'
import { RoleWidgetAssignment } from './RoleWidgetAssignment'
import { UserWidgetOverrides } from './UserWidgetOverrides'

export function WidgetAccess() {
  const [subView, setSubView] = useState<'role' | 'user'>('role')

  return (
    <div className='h-full flex flex-col space-y-4 overflow-y-auto pb-6'>
      <div className='flex p-1 bg-muted border border-border rounded-xl gap-1 w-fit h-9 items-stretch'>
        {(['role', 'user'] as const).map(view => (
          <button
            key={view}
            onClick={() => setSubView(view)}
            className={`px-4 text-xs font-medium transition-all duration-200 rounded-lg flex items-center justify-center ${
              subView === view
                ? 'bg-primary text-primary-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground hover:bg-white/5'
            }`}
          >
            {view === 'role' ? 'By Role' : 'By User'}
          </button>
        ))}
      </div>

      {subView === 'role' ? <RoleWidgetAssignment /> : <UserWidgetOverrides />}
    </div>
  )
}
